import { BettingOptionsClasses } from 'betgames-contract-js';
import { StarzleBetGroup } from '@bg-shared/enums/Starzle/StarzleBetGroup';

export const STARZLE_BONUS_OPTIONS = [
    BettingOptionsClasses.STARZLE_STAR,
    BettingOptionsClasses.STARZLE_MULTIPLIER,
    BettingOptionsClasses.STARZLE_BUST,
];

export const STARZLE_MAIN_OPTIONS = [BettingOptionsClasses.STARZLE_ONE_OUT_OF_ONE];

export const STARZLE_OPTIONS_BY_GROUP = {
    [StarzleBetGroup.MAIN_BET]: [BettingOptionsClasses.STARZLE_ONE_OUT_OF_ONE],
    [StarzleBetGroup.BONUS_NUMBER]: [BettingOptionsClasses.STARZLE_BONUS_ONE_OUT_OF_ONE],
    [StarzleBetGroup.PICK6]: [BettingOptionsClasses.STARZLE_PICK_6],
    [StarzleBetGroup.BONUS]: [
        BettingOptionsClasses.STARZLE_BONUS_BLUE,
        BettingOptionsClasses.STARZLE_BONUS_RED,
        BettingOptionsClasses.STARZLE_BONUS_WHITE,
        BettingOptionsClasses.STARZLE_BONUS_EVEN,
        BettingOptionsClasses.STARZLE_BONUS_ODD,
        BettingOptionsClasses.STARZLE_BONUS_OVER_24_5,
        BettingOptionsClasses.STARZLE_BONUS_UNDER_24_5,
    ],
    [StarzleBetGroup.EXTRAS]: [
        BettingOptionsClasses.STARZLE_COLOR_COCKTAIL_NO,
        BettingOptionsClasses.STARZLE_COLOR_COCKTAIL_YES,
        BettingOptionsClasses.STARZLE_FIRST_BLUE,
        BettingOptionsClasses.STARZLE_FIRST_RED,
        BettingOptionsClasses.STARZLE_FIRST_WHITE,
        BettingOptionsClasses.STARZLE_TOTAL_UNDER_147_5,
        BettingOptionsClasses.STARZLE_TOTAL_OVER_147_5,
    ],
};
